export default "__VITE_PUBLIC_ASSET__78201014__"